<template>
  <v-container fluid class="pl-md-5">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div v-if="list">
      <v-card height="100%" elevation="0" class="mb-3">
        <v-card-title
          v-if="$store.state.user.role === 'Nomad'"
          class="pa-4 light-blue white--text subtitle-1"
        >
          {{ $t("YouAreOn") }} {{ list.beltLevel }} {{ $t("Belt")
          }}{{ $t("Belt1") }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="2" class="text-center">
              <v-avatar v-if="!list.profilePic" color="light-blue" size="100">
                <span class="white--text text-h5">NR</span>
              </v-avatar>
              <v-avatar v-if="list.profilePic" size="100">
                <img :src="$store.state.baseUrl + list.profilePic" />
              </v-avatar>
              <v-dialog
                fullscreen
                v-model="dialog"
                width="50%"
                style="z-index: 5001"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark text color="light-blue" v-bind="attrs" v-on="on">
                    {{ $t("Changeavatar") }}
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title
                    class="headline light-blue darken-4 white--text"
                  >
                    {{ $t("Pickanavatar") }}
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      dark
                      x-small
                      fab
                      @click="dialog = false"
                    >
                      <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="pa-9">
                    <v-radio-group v-model="list.profilePic" row>
                      <v-radio
                        width="20%"
                        class="pa-5"
                        v-for="n in 115"
                        :key="n"
                        :value="'avatar/' + n + '.png'"
                        @change="updateprofilePic('avatar/' + n + '.png')"
                      >
                        <template v-slot:label>
                          <v-avatar size="62">
                            <img
                              :src="
                                $store.state.baseUrl + 'avatar/' + n + '.png'
                              "
                            />
                          </v-avatar>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="10">
              <h2 class="text-h6 mt-0 text-left">
                {{ list.firstName }} {{ list.lastName }}
              </h2>
              <v-row>
                <v-col cols="auto">
                  <p class="caption mb-1 text-left">
                    <v-icon small>mdi-calendar-account</v-icon>
                    <span class="ml-2">
                      {{ $t("Joinedin") }}
                      <span>
                        {{
                          format(
                            new Date($store.state.user.dateCreated),
                            "MMM yyyy"
                          )
                        }}
                      </span>
                    </span>
                  </p>
                  <div class="mb-1 caption">
                    <v-icon small>mdi-email</v-icon>
                    <span class="ml-3 mr-2 caption">{{ list.email }}</span>
                    <v-icon v-if="list.isEmailVerified" small color="green"
                      >mdi-check-decagram</v-icon
                    >
                    <v-icon v-if="!list.isEmailVerified" small color="red"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                  <div class="mb-1 caption">
                    <v-icon small>mdi-deskphone</v-icon>
                    <span class="ml-2 mr-2">{{ list.phone }}</span>
                    <v-icon v-if="list.isPhoneVerified" small color="green"
                      >mdi-check-decagram</v-icon
                    >
                    <v-icon v-if="!list.isPhoneVerified" small color="red"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                  <div class="mb-1 caption">
                    <v-icon small>mdi-card-account-details</v-icon>
                    <span class="ml-3 mr-2 caption">{{ $t("identity") }}</span>
                    <v-icon v-if="list.isIdVerified" small color="green"
                      >mdi-check-decagram</v-icon
                    >
                    <v-icon v-if="!list.isIdVerified" small color="red"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                </v-col>
                <v-col cols="auto" class="mr-auto">
                  <div class="caption mb-0 font-weight-bold">
                    {{ $t("Address") }}
                  </div>
                  <div class="caption">
                    {{ list.address }}, {{ list.address2 }}<br />{{
                      list.city
                    }}, {{ list.loc }}<br />{{ list.country }} -
                    {{ list.postalcode }}
                  </div>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    v-if="!list.isIdVerified"
                    small
                    dark
                    class="ma-2"
                    color="red"
                    to="/dashboard/confirm-identity"
                    >{{ $t("Confirmyouridentity") }}</v-btn
                  ><br />
                  <v-btn
                    small
                    dark
                    class="ma-2"
                    color="red"
                    to="/dashboard/account/deactivate"
                    >{{ $t("DeactivateAccount") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </v-container>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import timeoutMixin from "@/mixins/timeoutMixin.js";
import AuthService from "@/services/AuthService";
import { format } from "date-fns";

export default {
  name: "DashboardComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      format,
      error: null,
      loading: true,
      list: null,
      dialog: false,
      waitDialog: false
    };
  },
  async beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      var token = this.$store.state.token;
      await AuthService.profileDetailed({
        headers: { Authorization: "Bearer " + token }
      })
        .then(result => {
          this.$store.dispatch("setRole", result.data.user.role);
          this.list = result.data.user;
          this.loading = false;
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    }
  },
  methods: {
    updateprofilePic(item) {
      this.waitDialog = true;
      AuthService.changeProfilePic({ profilePic: item })
        .then(() => {
          this.dialog = false;
          this.$store.dispatch("setProfilePic", item);
        })
        .catch(err => {
          this.error = err.response.data.error;
          setTimeout(() => (this.error = null), 500);
        });
      setTimeout(() => (this.waitDialog = false), 500);
    }
  }
};
</script>

<style></style>
